<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="dialog"
      scrollable
      no-close-on-backdrop
      hide-header-close
      size="lg"
      :title="file ? $t('invoice') + ' ' + file : ''"
    >
      <template #modal-footer="{}">
        <b-button size="sm" variant="outline-secondary" @click="submit">
          {{ $t("save") }}
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel">
          {{ $t("back") }}
        </b-button>
      </template>
      <p class="">
        <validation-observer
          ref="companyRegisterValidation"
          name="RegisterCompany"
        >
          <b-form>
            <b-card class="col-md-12">
              <b-row m-0 p-0>
                <b-col cols="12" xl="6" md="6" lg="6">
                  <b-form-group
                    id="domicile-country-group"
                    :label="$t('domicile_country') + ':'"
                    label-for="domicile-country"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Country"
                      rules="required"
                    >
                      <b-form-select
                        id="domicile-country"
                        v-model="country_id"
                        :options="countries"
                        :state="errors.length > 0 ? false : null"
                        required
                        :disabled="disableInputs"
                      ></b-form-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    id="company-name-group"
                    :label="$t('company_name') + ':'"
                    label-for="company-name"
                  >
                    <vue-autosuggest
                      :suggestions="filteredOptions"
                      :limit="10"
                      v-model="company_name"
                      :input-props="{
                        id: 'autosuggest__input',
                        class: 'form-control',
                        placeholder: $t('select_company'),
                      }"
                      @selected="onSelected"
                      :get-suggestion-value="getSuggestionValue"
                      @input="searchForCompaniesName"
                    >
                      <template slot-scope="{ suggestion }">
                        <span class="my-suggestion-item"
                          >{{ suggestion.item }}
                        </span>
                      </template>
                    </vue-autosuggest>
                    <div class="mt-2">
                      {{ $t("company_uid") }}:
                      <b>{{ companies[company_name] }}</b>
                    </div>
                    <div
                      class="pt-1"
                      v-if="companies[company_name] != null && !successMessage"
                    >
                      <b-alert variant="primary" show>
                        <div class="alert-body">
                          <span>
                            {{ $t("fill_info_note") }}
                          </span>
                        </div>
                      </b-alert>
                    </div>
                    <div
                      v-if="companies[company_name] != null && successMessage"
                      class="pt-1"
                    >
                      <b-alert variant="success" show>
                        <div class="alert-body">
                          <span>{{ $t("succes_filled_data") }} </span>
                        </div>
                      </b-alert>
                    </div>

                    <b-row>
                      <b-col class="text-right pt-1" aling="end">
                        <b-button
                          variant="primary"
                          @click="getCompanyDataFromZefix()"
                          v-if="companies[company_name] != null"
                        >
                          <feather-icon icon="DownloadIcon" />
                          {{ $t("get_data") }}
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="6" md="6" lg="6">
                  <img src="/loader.svg" v-if="showLoader" />
                </b-col>
              </b-row>
            </b-card>
            <b-card>
              <b-row m-0 p-0>
                <b-col cols="12" xl="5" md="6" lg="6">
                  <b-form-group
                    id="company-name-field-group"
                    :label="$t('company_name') + ':'"
                    label-for="company-name-field"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Company Name"
                      rules="required"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend
                          is-text
                          :class="
                            company_name_after.length > 0
                              ? ''
                              : showBlueBorder
                              ? 'is-empty'
                              : ''
                          "
                        >
                          <feather-icon
                            icon="HomeIcon"
                            class="cursor-pointer"
                          />
                        </b-input-group-prepend>
                        <b-form-input
                          :class="
                            company_name_after.length > 0
                              ? ''
                              : showBlueBorder
                              ? 'is-empty'
                              : ''
                          "
                          id="company-name-field"
                          v-model="company_name_after"
                          required
                          :state="errors.length > 0 ? false : null"
                          :disabled="disableInputs"
                        ></b-form-input>
                      </b-input-group>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="4" md="4" lg="4">
                  <b-form-group
                    id="company-address-group"
                    :label="$t('company-address') + ':'"
                    label-for="company-address"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Company Address"
                      rules="required"
                    >
                      <b-form-input
                        :class="
                          company_address.length > 0
                            ? ''
                            : showBlueBorder
                            ? 'is-empty'
                            : ''
                        "
                        id="company-address"
                        v-model="company_address"
                        :state="errors.length > 0 ? false : null"
                        required
                        :disabled="disableInputs"
                      ></b-form-input>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="3" md="2" lg="2">
                  <b-form-group
                    id="company-address-nr-group"
                    :label="$t('company-address-nr') + ':'"
                    label-for="company-address-nr"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Company Address Nr"
                      rules="required"
                    >
                      <b-form-input
                        id="company-address-nr"
                        :class="
                          company_address_nr.length > 0
                            ? ''
                            : showBlueBorder
                            ? 'is-empty'
                            : ''
                        "
                        v-model="company_address_nr"
                        required
                        :state="errors.length > 0 ? false : null"
                        :disabled="disableInputs"
                      ></b-form-input>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row m-0 p-0>
                <b-col cols="12" xl="6" md="6" lg="6">
                  <b-form-group
                    id="company-uid-group"
                    :label="
                      $t('company_uid') + ' (CHE-397.517.219 > CHE397517219):'
                    "
                    label-for="company-uid"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Company UID"
                    >
                      <b-form-input
                        id="company-uid"
                        :class="
                          company_uid.length > 0
                            ? ''
                            : showBlueBorder
                            ? 'is-empty'
                            : ''
                        "
                        v-model="company_uid"
                        disabled
                        :state="errors.length > 0 ? false : null"
                      ></b-form-input>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="2" md="2" lg="2">
                  <b-form-group
                    id="company-zip-group"
                    :label="$t('zip') + ':'"
                    label-for="company-zip"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Company Zip"
                      rules="required"
                    >
                      <b-form-input
                        :class="
                          company_zip.length > 0
                            ? ''
                            : showBlueBorder
                            ? 'is-empty'
                            : ''
                        "
                        id="company-zip"
                        v-model="company_zip"
                        required
                        :state="errors.length > 0 ? false : null"
                        :disabled="disableInputs"
                      ></b-form-input>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="4" md="4" lg="4">
                  <b-form-group
                    id="company-city-group"
                    :label="$t('city') + ':'"
                    label-for="company-city"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Company City"
                      rules="required"
                    >
                      <b-form-input
                        id="company-city"
                        :class="
                          company_city.length > 0
                            ? ''
                            : showBlueBorder
                            ? 'is-empty'
                            : ''
                        "
                        v-model="company_city"
                        required
                        :state="errors.length > 0 ? false : null"
                        :disabled="disableInputs"
                      ></b-form-input>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row m-0 p-0>
                <b-col cols="12" xl="6" md="6" lg="6">
                  <b-form-group
                    id="company-legal-form-group"
                    :label="$t('legal_form') + ':'"
                    label-for="company-legal-form"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Company Legal Form"
                      rules="required"
                    >
                      <b-form-select
                        id="company-legal-form"
                        v-model="company_legal_form"
                        :class="
                          company_legal_form.length > 0
                            ? ''
                            : showBlueBorder
                            ? 'is-empty'
                            : ''
                        "
                        :options="legal_forms"
                        required
                        :state="errors.length > 0 ? false : null"
                        :disabled="disableInputs"
                      ></b-form-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="6" md="6" lg="6">
                  <b-form-group
                    id="company-website-group"
                    :label="$t('website') + ':'"
                    label-for="company-website"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend
                        is-text
                        :class="
                          company_website.length > 0
                            ? ''
                            : showBlueBorder
                            ? 'is-empty'
                            : ''
                        "
                      >
                        <feather-icon icon="GlobeIcon" class="cursor-pointer" />
                      </b-input-group-prepend>
                      <b-form-input
                        :class="
                          company_website.length > 0
                            ? ''
                            : showBlueBorder
                            ? 'is-empty'
                            : ''
                        "
                        id="company-website"
                        v-model="company_website"
                        required
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>

            <h5>{{ $t("main_contact_person") }}</h5>
            <b-card>
              <b-row m-0 p-0>
                <b-col cols="12" xl="6" md="6" lg="6">
                  <b-form-group
                    id="main-contact-gender-group"
                    :label="$t('salutation') + ':'"
                    label-for="main-contact-gender"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend
                        is-text
                        :class="
                          main_contact_gender.length > 0
                            ? ''
                            : showBlueBorder
                            ? 'is-empty'
                            : ''
                        "
                      >
                        <feather-icon icon="UserIcon" class="cursor-pointer" />
                      </b-input-group-prepend>
                      <b-form-select
                        id="main-contact-gender"
                        :class="
                          main_contact_gender.length > 0
                            ? ''
                            : showBlueBorder
                            ? 'is-empty'
                            : ''
                        "
                        v-model="main_contact_gender"
                        :options="[
                          {
                            text: $t('select_one'),
                            value: null,
                            disabled: true,
                          },
                          { text: $t('mr'), value: '0' },
                          { text: $t('mrs'), value: '1' },
                        ]"
                        required
                      ></b-form-select>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="6" md="6" lg="6">
                  <b-form-group
                    id="main-contact-email-group"
                    :label="$t('company_email_address') + ':'"
                    label-for="main-contact-email"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Number of Debtors"
                      rules="required|email"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend
                          is-text
                          :class="
                            main_contact_email.length > 0
                              ? ''
                              : showBlueBorder
                              ? 'is-empty'
                              : ''
                          "
                        >
                          <feather-icon
                            icon="MailIcon"
                            class="cursor-pointer"
                          />
                        </b-input-group-prepend>
                        <b-form-input
                          id="main-contact-email"
                          v-model="main_contact_email"
                          :class="
                            main_contact_email.length > 0
                              ? ''
                              : showBlueBorder
                              ? 'is-empty'
                              : ''
                          "
                          required
                          disabled
                          :state="errors.length > 0 ? false : null"
                        ></b-form-input>
                      </b-input-group>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row m-0 p-0>
                <b-col cols="12" xl="6" md="6" lg="6">
                  <b-form-group
                    id="main-contact-first-name-group"
                    :label="$t('first_name') + ':'"
                    label-for="main-contact-first-name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="First name"
                      rules="required"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend
                          is-text
                          :class="
                            main_contact_first_name.length > 0
                              ? ''
                              : showBlueBorder
                              ? 'is-empty'
                              : ''
                          "
                        >
                          <feather-icon
                            icon="UserIcon"
                            class="cursor-pointer"
                          />
                        </b-input-group-prepend>
                        <b-form-input
                          id="main-contact-first-name"
                          v-model="main_contact_first_name"
                          required
                          :class="
                            main_contact_first_name.length > 0
                              ? ''
                              : showBlueBorder
                              ? 'is-empty'
                              : ''
                          "
                          :state="errors.length > 0 ? false : null"
                          :disabled="disableInputs"
                        ></b-form-input>
                      </b-input-group>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="6" md="6" lg="6">
                  <b-form-group
                    id="main-contact-tel-group"
                    :label="$t('tel') + ':'"
                    label-for="main-contact-tel"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="tel"
                      rules="required"
                    >
                      <b-input-group>
                        <b-input-group-prepend id="phoneCountries">
                          <b-form-select
                            :options="phoneCountriesList"
                            v-model="phoneContries"
                          >
                          </b-form-select>
                        </b-input-group-prepend>
                        <b-form-input
                          id="main-contact-tel"
                          v-model="main_contact_tel"
                          @input="checkPhoneFormat"
                          class="form-control"
                          :state="errors.length > 0 ? false : null"
                        >
                        </b-form-input>
                      </b-input-group>

                      <small class="text-danger">{{ errors[0] }}</small>
                      <small class="text-danger" v-if="phoneValidation">{{
                        phoneValidation
                      }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row m-0 p-0>
                <b-col cols="12" xl="6" md="6" lg="6">
                  <b-form-group
                    id="main-contact-last-name-group"
                    :label="$t('last_name') + ':'"
                    label-for="main-contact-last-name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Last Name"
                      rules="required"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend
                          is-text
                          :class="
                            main_contact_last_name.length > 0
                              ? ''
                              : showBlueBorder
                              ? 'is-empty'
                              : ''
                          "
                        >
                          <feather-icon
                            icon="UserIcon"
                            class="cursor-pointer"
                          />
                        </b-input-group-prepend>
                        <b-form-input
                          id="main-contact-last-name"
                          v-model="main_contact_last_name"
                          :class="
                            main_contact_last_name.length > 0
                              ? ''
                              : showBlueBorder
                              ? 'is-empty'
                              : ''
                          "
                          required
                          :state="errors.length > 0 ? false : null"
                          :disabled="disableInputs"
                        ></b-form-input>
                      </b-input-group>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="6" md="6" lg="6">
                  <b-form-group
                    id="main-contact-position-group"
                    :label="$t('position_in_the_company') + ':'"
                    label-for="main-contact-position"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Position in the Company"
                      rules="required"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend
                          is-text
                          :class="
                            main_contact_position.length > 0
                              ? ''
                              : showBlueBorder
                              ? 'is-empty'
                              : ''
                          "
                        >
                          <feather-icon
                            icon="BriefcaseIcon"
                            class="cursor-pointer"
                          />
                        </b-input-group-prepend>
                        <b-form-input
                          id="main-contact-position"
                          v-model="main_contact_position"
                          :class="
                            main_contact_position.length > 0
                              ? ''
                              : showBlueBorder
                              ? 'is-empty'
                              : ''
                          "
                          required
                          :state="errors.length > 0 ? false : null"
                          :disabled="disableInputs"
                        ></b-form-input>
                      </b-input-group>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-form>
        </validation-observer>
      </p>
    </b-modal>
  </div>
</template>


<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { VueAutosuggest } from "vue-autosuggest";

import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormSelect,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BButton,
  BFormDatepicker,
  BFormRadio,
  BFormRadioGroup,
  BFormCheckbox,
  BAlert,
  BInputGroupPrepend,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BButton,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BInputGroup,
    BFormCheckbox,
    BFormDatepicker,
    BFormRadio,
    BFormRadioGroup,
    BAlert,
    BInputGroup,
    BInputGroupPrepend,

    ValidationProvider,
    ValidationObserver,
    VueAutosuggest,
  },
  data() {
    return {
      filteredOptions: [],
      showLoader: false,
      disableInputs: false,
      country_id: 1,
      countries: [],
      company_id: this.$store.state.auth.user.company_id,
      company_name: "",
      company_name_after: "",
      companies: [],
      company_zefix_data: null,
      company_address: "",
      company_address_nr: "",
      company_uid: "",
      company_zip: "",
      company_city: "",
      company_legal_form: "",
      company_website: "",
      dialog: false,
      legal_forms: [
        "Aktiengesellschaft",
        "Gesellschaft mit beschränkter Haftung",
        "Einzelunternehmen",
      ],
      company_established_at: "",
      number_of_employees: "",
      annual_turnover: "",
      intent_to_sell: "",
      number_of_debtors: "",
      debt_enforcement: "Yes",
      intent_to_sell_values: [
        "1% - 10%",
        "11% - 20%",
        "21% - 30%",
        "31% - 50%",
        "51% - 70%",
        "71% - 80%",
        "81% - 90%",
        "91% - 100%",
      ],
      number_of_debtors_values: [
        "1-10",
        "11-20",
        "21-50",
        "51-100",
        "101-200",
        "201-500",
        "500+",
      ],
      debt_enforcement_values: ["Yes", "No"],
      main_contact_gender: "",
      main_contact_email: this.$store.state.auth.user.email,
      main_contact_first_name: this.$store.state.auth.user.first_name,
      main_contact_last_name: this.$store.state.auth.user.last_name,
      main_contact_tel: "",
      main_contact_position: "",
      signing_authority_type: "",
      signing_authority_type_values: [
        this.$t("sole_signatory"),
        this.$t("collectively_by_two"),
        this.$t("only_contact_person"),
      ],
      signators: [
        {
          gender: "",
          first_name: "",
          email: "",
          last_name: "",
          tel: "",
          position: "",
          signing_authority_type: "",
        },
      ],
      terms_and_conditions: "",
      data_privacy: "",
      hideSigners: true,
      successMessage: false,
      showBlueBorder: false,
      phoneContries: "",
      phoneCountriesList: [],
    };
  },
  props: ["file", "showDialog"],
  name: "AddCompany",
  watch: {
    showDialog(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.dialog = newValue;
      }
    },
  },
  created() {
    this.$http.post("/countries").then((res) => {
      res.data.value.map((item) => {
        this.phoneCountriesList.push({
          value: item.iso_code,
          text: `${item.iso_code} (${item.phone_code})`,
        });

        this.countries.push({
          value: item.id,
          text: item.name,
        });
      });
    });
  },
  methods: {
    toggleDarkMode() {
      let color = "";
      if (this.$store.state.verticalMenu.lightMode == "light") {
        color = "background:white";
      } else {
        color = "background:#283046";
      }
      return color;
    },
    hideSignersPart() {
      if (this.signing_authority_type == "Sole signatory") {
        this.hideSigners = false;
        this.signators = [];
      } else {
        this.hideSigners = true;
        this.addNewSigner();
      }
    },
    saveCompanyInfo() {
      this.$refs.companyRegisterValidation.validate().then((success) => {
        if (success) {
          this.disableInputs = true;
          const formSubmissionData = {
            company_id: this.company_id,
            company_name: this.company_name_after,
            company_address: this.company_address,
            company_address_nr: this.company_address_nr,
            company_uid: this.company_uid,
            company_zip: this.company_zip,
            company_city: this.company_city,
            company_country_id: this.country_id,
            company_website: this.company_website,
            legal_form: this.company_legal_form,
            main_contact_person_gender: this.main_contact_gender,
            main_contact_first_name: this.main_contact_first_name,
            main_contact_last_name: this.main_contact_last_name,
            main_contact_position: this.main_contact_position,
            main_contact_tel: this.main_contact_tel,
            signing_authority_type: this.signing_authority_type,
            established_at: this.company_established_at,
            number_of_employees: Number(this.number_of_employees),
            annual_turnover: Number(this.annual_turnover),
            intent_to_sell: this.intent_to_sell,
            number_of_debtors: this.number_of_debtors,
            debt_enforcement: this.debt_enforcement,
            signers: this.signators.length,
            terms_and_conditions: this.terms_and_conditions,
            data_privacy: this.data_privacy,
            placeholder: 1,
            iso_code: this.phoneContries,
          };
          let data = {};
          if (this.signators.length > 0) {
            this.signators.map((item, i) => {
              const nr = i + 1;
              const signator = {
                ["signator_" + nr + "_gender"]: item.gender,
                ["signator_" + nr + "_first_name"]: item.first_name,
                ["signator_" + nr + "_last_name"]: item.last_name,
                ["signator_" + nr + "_email"]: item.email,
                ["signator_" + nr + "_tel"]: item.tel,
                ["signator_" + nr + "_position"]: item.position,
                ["signator_" + nr + "_signing_authority_type"]:
                  item.signing_authority_type,
              };
              data = { ...formSubmissionData, ...signator };
            });
          } else {
            data = formSubmissionData;
          }
          this.$http.post("/company/store", data).then((res) => {
            document.getElementById("show-settings").click();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t("company_registered_successfully"),
                icon: "SuccessIcon",
                variant: "success",
              },
            });
            this.$router.push("/");
          });
        }
        this.disableInputs = false;
      });
    },
    deleteSignator(index) {
      this.signators.splice(index, 1);
    },
    onSelected() {
      this.successMessage = false;
    },
    getSuggestionValue(value) {
      this.company_name = value.item;
    },
    searchForCompaniesName() {
      if (this.company_name.length > 2) {
        this.filteredOptions = [];
        this.$http
          .post("/get-companies-name-from-zefix", { search: this.company_name })
          .then((res) => {
            this.successMessage = false;
            this.filteredOptions.push({ data: Object.keys(res.data.value) });
            this.companies = res.data.value;
          });
      } else {
        this.companies = [];
        this.filteredOptions = [];
      }
    },
    checkPhoneFormat() {
      let validation = phone(this.main_contact_tel, {
        country: this.phoneContries,
        validateMobilePrefix: false
      });

      if (validation && validation.isValid == false) {
        this.phoneValidation = `Phone for ${this.phoneContries} must be valid`;
      } else {
        this.phoneValidation = "";
      }
    },
    getCompanyDataFromZefix() {
      this.showLoader = true;
      if (typeof this.companies[this.company_name] != "undefined") {
        this.$http
          .post("/get-company-data-from-zefix", {
            search: this.companies[this.company_name],
          })
          .then((res) => {
            this.company_zefix_data = res.data.value;
            this.company_uid = this.company_zefix_data.uid;
            this.company_name_after = this.company_zefix_data.name;
            this.company_address = this.company_zefix_data.address.street;
            this.company_address_nr =
              this.company_zefix_data.address.houseNumber;
            this.company_city = this.company_zefix_data.address.city;
            this.company_zip = this.company_zefix_data.address.swissZipCode;
            this.company_legal_form = this.company_zefix_data.legalForm.name.de;
            this.company_established_at = this.company_zefix_data.sogcDate;
            this.showLoader = false;
            this.successMessage = true;
            this.showBlueBorder = true;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t("data_received_successfully"),
                icon: "SuccessIcon",
                variant: "success",
              },
            });
          });
      }
    },
    addNewSigner() {
      if (this.signators.length < 5) {
        this.signators.push({
          gender: "Mr",
          first_name: null,
          email: null,
          last_name: null,
          tel: null,
          position: null,
          signing_authority_type: null,
        });
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("you_can_add_only_up_to_5_signatory"),
            icon: "ErrorIcon",
            variant: "error",
          },
        });
      }
    },
    submit() {},
    cancel() {
      this.$emit("closeAddCompModal");
    },
    onSubmit(event) {
      event.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(event) {
      event.preventDefault();
      this.country_id = 0;
      this.countries = [];
    },
  },
};
</script>

<style></style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>









